import React, { useEffect, useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { ISubject, ITeacher } from "common/types";
import Spinner from "../../spinner";
import api from "common/api";
import usePageTitle from "common/usePageTitle";

function InstructorsPage() {
  const [teachers, setTeachers] = useState<ITeacher[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  usePageTitle("Nastavnici");

  useEffect(() => {
    const fetchTeachers = async () => {
      setLoading(true);
      try {
        const response = await api.get("/teachers/");
        setTeachers(response.data);
      } catch (error) {
        console.log("error");
      } finally {
        setLoading(false);
      }
    };

    fetchTeachers();
  }, []);

  return (
    <Row>
      <h1>Nastavnici</h1>

      <hr />

      {loading ? (
        <Spinner />
      ) : (
        <Container>
          {teachers.map((teacher) => (
            <Row key={teacher.user_id} className="mb-3">
              <Col xs="auto">
                <Image
                  src={
                    teacher?.profile?.picture ||
                    "https://via.placeholder.com/200"
                  }
                  alt={teacher.first_name}
                  style={{
                    width: "250px",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                  loading="lazy"
                />
              </Col>
              <Col className="pt-3 px-4">
                <h2>
                  {teacher.first_name} {teacher.last_name}
                  {teacher.profile?.title && `, ${teacher.profile.title}`}
                </h2>
                <p>{teacher.profile?.remark}</p>
              </Col>
            </Row>
          ))}
        </Container>
      )}
    </Row>
  );
}

export default InstructorsPage;
